import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

export const CampaignSchema = z.object({
	id: z.string(),
	name: z.string(),
	listId: z.number(),
	listName: z.string(),
	isValid: z.boolean(),
	initialEdges: z.any(),
	initialNodes: z.any(),
	eventAt: z.string(),
	senders: z.array(z.any()),
	schedule: z.array(z.any()),
	timezone: z.string(),
	isDefault: z.boolean(),
	languages: z.array(z.string()),
	isEventBase: z.boolean(),
	trackClicks: z.boolean(),
	trackOpens: z.boolean(),
	stopCampaignAt: z.string(),
	pausePeopleFromTheSameCompany: z.boolean(),
});

export const CampaignResponseSchema = z.object({
	data: z.array(CampaignSchema),
	meta: MetaDataSchema,
});

export type Campaign = z.infer<typeof CampaignSchema>;
export type CampaignResponse = z.infer<typeof CampaignResponseSchema>;
